import { render, staticRenderFns } from "./GenerateInvoices.vue?vue&type=template&id=676cf6f8&scoped=true&"
import script from "./GenerateInvoices.vue?vue&type=script&lang=js&"
export * from "./GenerateInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676cf6f8",
  null
  
)

export default component.exports